import $ from 'jquery';
import Isotope from 'isotope-layout';
import 'isotope-packery';
import 'jquery.cookie';

/**
 * Mobile navigation toggle
 * @param  {mixed} event
 */

const toggleMenu = (event) => {
    event.preventDefault();
    $('.js-menu-toggle, .nav--header').toggleClass('open');
    $('.header, body').toggleClass('menu-open');
    $('.header__navigation').fadeToggle();
};

$('.js-menu-toggle').on('click', toggleMenu);

/**
 * Isotope layout
 */

$(window).on('load', function() { 

  var grid = $('.isotope-grid');

  if (grid.length)
  {
    var iso = new Isotope( grid.get(0), {
      itemSelector: '.grid-item',
      layoutMode: 'packery',
    });
  }

});

/**
 * Password form
 */

$(window).on('load', function() {

  if (!$.cookie('password_entry'))
  {
    $('.modal--password').show();
  }

});

$('#form-password').on('submit', function(e) {

  e.preventDefault();

  var password = $('[name="password"]', $(this)).val();

  $.post( site.ajax_url, {
    action: 'password_protection',
    password: password,
  }, function(response) {

    if (response == 1)
    {
      $.cookie('password_entry', true, { expires: 7, path: '/' });
      $('.modal--password').fadeOut();
    }
    else
    {
      $('[data-error="password"]').text('The password you entered is not incorrect');
    }

  });

});